import { Ref } from "react";
import SlickSlider from "react-slick";

/**
 * Executes an action on all valid slider instances in the provided collection of refs.
 *
 * @param refs - Collection of slider refs (Set or any iterable)
 * @param action - Function to execute on each valid slider instance
 */
export const executeOnAllSliders = (
  refs: Set<Ref<SlickSlider>> | Iterable<Ref<SlickSlider>>,
  action: (slider: SlickSlider, ref: Ref<SlickSlider>) => void,
): void => {
  const refsIterable = refs instanceof Set ? refs : new Set(refs);

  refsIterable.forEach((ref) => {
    if (typeof ref === "object" && ref?.current) {
      action(ref.current, ref);
    }
  });
};
